import cookie from 'js-cookie'

import { entityDefault, EntityList } from '@/types/Entity'

export const LOCALSTORAGE_KEY_ENTITY = 'entity'

// Etat module : source de verite cote client pour l'entite multi-entites.
// Remplace l'ancien stockage dans le cache Apollo (LOCAL.GET_ENTITY / entity @client).
let current: EntityList | undefined

type Listener = () => void
const listeners = new Set<Listener>()

const readCookie = (): EntityList | undefined => {
  if (typeof document === 'undefined') return undefined
  const value = cookie.get(LOCALSTORAGE_KEY_ENTITY)
  return value ? (value as EntityList) : undefined
}

/**
 * Snapshot lu par useSyncExternalStore (client) et getEntityForRoute.
 * Priorite : etat module > cookie > defaut.
 */
export const getEntitySnapshot = (): EntityList => current ?? readCookie() ?? entityDefault

/**
 * Snapshot deterministe cote serveur (anti-mismatch d'hydratation).
 * Le serveur ne lit ni l'etat module client ni le cookie navigateur : il
 * renvoie toujours `entityDefault` (ou la valeur seedee via initEntity lors du
 * render). Le client se resynchronise via le cookie au premier snapshot client.
 */
export const getEntityServerSnapshot = (): EntityList => current ?? entityDefault

const notify = (): void => {
  listeners.forEach(listener => listener())
}

/**
 * Met a jour l'entite courante, persiste le cookie et notifie les abonnes.
 */
export const setEntityValue = (value: EntityList): void => {
  current = value
  cookie.set(LOCALSTORAGE_KEY_ENTITY, value, {
    expires: 1,
  })
  notify()
}

/**
 * Seed initial (SSR -> render) sans reecrire le cookie.
 * N'ecrase pas une valeur deja choisie par l'utilisateur dans la session.
 */
export const initEntity = (value?: EntityList | null): void => {
  if (current === undefined && value) {
    current = value
    notify()
  }
}

export const subscribeEntity = (callback: Listener): (() => void) => {
  listeners.add(callback)
  return () => {
    listeners.delete(callback)
  }
}
